module.exports = __webpack_public_path__ + "img/stone.pickaxe.2dbee053.png";